import { FC, useState } from 'react';

import { useCurrentEntertainerQuery } from '@queries/EntertainerQueries';

import { useUserOnboardingMutation } from '@mutations/UserMutations';

import { useNavigate } from '@router/index';

import { createScreenComponent } from '@utilities/createScreenComponent';
import { openExternalUrl } from '@utilities/openExternalUrl';

import Button from '@components/buttons/Button';
import { FormLabel } from '@components/form/FormLabel';
import { Input } from '@components/form/Input';
import Card from '@components/layout/Card/Card';
import { List } from '@components/layout/List/List';
import { Screen } from '@components/layout/Screen/Screen';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

import { DRAG_NAMES } from './OnboardingBasicInfoScreen/DragNames';
import { ONBOARDING_STEP_COUNT } from './OnboardingConstants';

const getRandomDragName = () => {
  return DRAG_NAMES[Math.floor(Math.random() * DRAG_NAMES.length)];
};

const AUTH_IS_MAGIC_LINK = false;

export const OnboardingUserTypeScreen = createScreenComponent(() => {
  const defaultDisplayName = getRandomDragName();
  const { entertainer: currentEntertainer } = useCurrentEntertainerQuery();
  const [displayName, setDisplayName] = useState<string>(defaultDisplayName);
  const { updateUserOnboardingAsync, isSubmitting } = useUserOnboardingMutation();
  const navigate = useNavigate();

  const handleGoToNextStep = async () => {
    if (!displayName) {
      return;
    }

    await updateUserOnboardingAsync({
      displayName,
    });

    navigate('/onboarding/interests');
  };

  return (
    <Screen name="Onboarding User Type Screen" hideToolbar>
      <Screen.Content>
        <TitleToolbar text="Welcome to Gaggl!" className="mb-0" />
        <div className="mb-2">
          We're so glad you're here! Before we get started, we'd love to know a bit about you so we
          can make your experience amazing.
        </div>
        <div className="mb-4">
          Are you a performer looking to share your talents, or are you here to explore whats
          happening in the community?
        </div>
        <Card>
          {/* <Card.Header title="⬇️ Are you..." className="pt-1 pb-0" /> */}
          <List
            style={{
              // borderTop: '1px solid rgba(255,255,255,.1)',
              background: 'rgba(0,0,0,.25)',
            }}
            listItems={[
              {
                hasCheckbox: true,
                title: "I'm an entertainer",
                subTitle:
                  'Show off your skills, share your availability, and get discovered for upcoming gigs.',
                onClick: () =>
                  navigate(!currentEntertainer?._id ? '/entertainer/onboarding' : '/', {
                    state: {
                      onCompletePath: '/',
                    },
                  }),
              },
              {
                hasCheckbox: true,
                title: "I'm here for the vibe",
                subTitle:
                  'Stay in the loop, support local artists, and discover nearby LGBTQ+ events.',
                onClick: () => navigate('/onboarding/basic-info'),
              },
            ]}
          />
        </Card>
      </Screen.Content>
    </Screen>
  );
});
